module.exports = __webpack_public_path__ + "img/ltkmens-3x.5322f78.jpg";